import toast from "react-hot-toast";
import CustomToast from "./custom-toast";
import { translateApiErrorWithCode } from "../../../utils/translate-api-error";

export const showToast = {
  success: (title: string, message?: string) =>
    toast.custom((t) => (
      <CustomToast
        t={t}
        icon="check_circle"
        iconClass="text-emerald-500"
        bgIcon="bg-emerald-500/10"
        accentClass="bg-emerald-500"
        title={title}
        message={message}
      />
    )),

  error: (title: string, message?: string) =>
    toast.custom((t) => (
      <CustomToast
        t={t}
        icon="error"
        iconClass="text-red-500"
        bgIcon="bg-red-500/10"
        accentClass="bg-red-500"
        title={title}
        message={message}
      />
    )),

  errorApi: (error: unknown, message?: string) =>
    toast.custom((t) => (
      <CustomToast
        t={t}
        icon="error"
        iconClass="text-red-500"
        bgIcon="bg-red-500/10"
        accentClass="bg-red-500"
        title={translateApiErrorWithCode(error)}
        message={message}
      />
    )),

  warning: (title: string, message?: string) =>
    toast.custom((t) => (
      <CustomToast
        t={t}
        icon="warning"
        iconClass="text-amber-500"
        bgIcon="bg-amber-500/10"
        accentClass="bg-amber-500"
        title={title}
        message={message}
      />
    )),

  /**
   * Notification d'un message reçu. Cliquable : elle mène au fil concerné, la
   * discussion étant rarement ouverte au moment où le message arrive.
   */
  message: (title: string, message: string, onClick?: () => void) =>
    toast.custom((t) => (
      <CustomToast
        t={t}
        icon="chat"
        iconClass="text-primary"
        bgIcon="bg-primary/10"
        accentClass="bg-primary"
        title={title}
        message={message}
        onClick={
          onClick &&
          (() => {
            toast.dismiss(t.id);
            onClick();
          })
        }
      />
    )),

  /**
   * Notification de suivi d'une course, réservée au back-office. Cliquable :
   * elle mène à la fiche, un gestionnaire prévenu voulant presque toujours
   * regarder la course dont on lui parle.
   *
   * Elle s'efface comme les autres : ce qui doit être retrouvé plus tard vit
   * dans la cloche, qui tient le fil complet côté serveur. Un toast persistant
   * n'aurait de sens que sans cette mémoire — et empilerait les réservations
   * d'une longue journée à l'écran.
   */
  course: (title: string, message: string, onClick?: () => void) =>
    toast.custom((t) => (
      <CustomToast
        t={t}
        icon="local_taxi"
        iconClass="text-primary"
        bgIcon="bg-primary/10"
        accentClass="bg-primary"
        title={title}
        message={message}
        onClick={
          onClick &&
          (() => {
            toast.dismiss(t.id);
            onClick();
          })
        }
      />
    )),

  info: (title: string, message?: string) =>
    toast.custom((t) => (
      <CustomToast
        t={t}
        icon="info"
        iconClass="text-primary"
        bgIcon="bg-primary/10"
        accentClass="bg-primary"
        title={title}
        message={message}
      />
    )),
};
